import React from 'react';

type AIAssistantErrorBoundaryProps = {
  children: React.ReactNode;
};

type AIAssistantErrorBoundaryState = {
  hasError: boolean;
};

class AIAssistantErrorBoundary extends React.Component<AIAssistantErrorBoundaryProps, AIAssistantErrorBoundaryState> {
  state: AIAssistantErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): AIAssistantErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    // eslint-disable-next-line no-console
    console.error('AI Assistant widget crashed and was disabled for this session:', error);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default AIAssistantErrorBoundary;
